import {
  ChallengeField,
  ChallengeFieldError,
  ChallengeRowContent,
  ChallengeRowGroup,
  ChallengeRowNumber,
} from '@/components/challenge/components';
import { EMPTY_ONLY_LABEL_ERROR } from '@/components/challenge/CompanyChallengeManagement/constants';
import { IChallengeFormValues } from '@/components/challenge/CompanyChallengeManagement/types';
import { DeleteIcon } from '@/components/icons';
import { IChallengeLabel } from '@/types/challenges';
import { Box, IconButton } from '@mui/material';
import { useFormikContext } from 'formik';
import { FC } from 'react';

interface ChallengeLabelRowProps {
  label: IChallengeLabel;
  displayIndex: number;
  canRemove: boolean;
  onRemove: () => void;
}

export const ChallengeLabelRow: FC<ChallengeLabelRowProps> = ({
  label,
  displayIndex,
  canRemove,
  onRemove,
}) => {
  const { errors, touched, handleChange, handleBlur } =
    useFormikContext<IChallengeFormValues>();

  const labelRowError = errors.labels?.[displayIndex];
  const rawLabelError = touched.labels?.[displayIndex]?.label
    ? typeof labelRowError === 'object'
      ? labelRowError.label
      : undefined
    : undefined;

  const labelError =
    rawLabelError && !canRemove ? EMPTY_ONLY_LABEL_ERROR : rawLabelError;

  return (
    <ChallengeRowGroup>
      <ChallengeRowContent>
        <ChallengeRowNumber>{displayIndex + 1}.</ChallengeRowNumber>
        <Box flex={1} minWidth={0}>
          <ChallengeField
            fullWidth
            name={`labels.${displayIndex}.label`}
            placeholder={`Enter label ${displayIndex + 1}`}
            value={label.label}
            onChange={handleChange}
            onBlur={handleBlur}
            error={Boolean(labelError)}
          />
        </Box>
        <IconButton
          aria-label={`Remove label ${displayIndex + 1}`}
          onClick={onRemove}
          disabled={!canRemove}
        >
          <DeleteIcon />
        </IconButton>
      </ChallengeRowContent>
      {labelError && <ChallengeFieldError>{labelError}</ChallengeFieldError>}
    </ChallengeRowGroup>
  );
};
